module.exports = __webpack_public_path__ + "img/phone-bottom.485dfd16.svg";